// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"6b8290e1","796":"14ea75da"}[chunkId] + ".chunk.css";
};